export default "__VITE_ASSET__Cp0Gv06p__"